export class GruppiNazionalitaItem {
	constructor() {
		this.itemID = null;
		this.gruppoNazionalita = null;
		this.descrizione = null;
		this.isDefault = null;
		this.codiceGruppo = null;
		this.esclusione = null;
		this.raggruppaRiepilogo = null;
		this.deleted = null;
	}
	itemID: number;
	gruppoNazionalita: string;
	descrizione: string;
	isDefault: boolean | null;
	codiceGruppo: string;
	esclusione: boolean | null;
	raggruppaRiepilogo: string;
	deleted: boolean | null;
}